<div class="site-saving-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title style="color: #1976d2; margin: 0;">INFO</h2>
  </div>
  
  <mat-dialog-content style="padding: 20px; min-height: 80px;">
    <div style="display: flex; align-items: center; margin-bottom: 16px;">
      <!-- <mat-spinner diameter="40" style="margin-right: 16px;"></mat-spinner> -->
      <div style="flex: 1;">
        <p style="font-size: 16px; color: #333; margin: 0; line-height: 1.5; display: flex; align-items: center;">
          <i class="fa fa-info-circle fa-2x" aria-hidden="true" style="margin-right: 12px; flex-shrink: 0;"></i>
          <span>{{ data.message || 'Site configuration is saving. Please wait...' }}</span>
        </p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions style="padding: 20px; display: flex; justify-content: flex-end; gap: 12px; border-top: 1px solid #e0e0e0;">
    <!-- <button 
      mat-raised-button 
      color="accent" 
      (click)="onWait()"
      style="background-color: #6c757d; color: white; min-width: 140px;">
      Wait
    </button> -->
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onHome()"
      style="background-color: #1976d2; color: white; min-width: 140px;">
      Home
    </button>
  </mat-dialog-actions>
</div>

